import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiEventsService {
  private actionSubject = new Subject<void>();

  emitAction() {
    this.actionSubject.next();
  }

  onAction$(): Observable<void> {
    return this.actionSubject.asObservable();
  }
}
